<template>
  <b-sidebar
    class="sidebarWrapper"
    id="sidebar-1"
    title="Menú"
    shadow
    :visible="true"
    no-close-on-route-change
    no-header-close
  >
    <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->

    <b-nav vertical>
      <b-nav-item :to="{ name: 'AdminMainScreen' }">Inicio</b-nav-item>

      <b-nav-item
        v-if="isFullEmployee || isBarcelonaEmployee || isMadridEmployee"
        v-b-toggle:nav-collapse-common
        >Común</b-nav-item
      >
      <b-collapse
        id="nav-collapse-common"
        :visible="isFullEmployee || isBarcelonaEmployee || isMadridEmployee"
      >
        <b-dropdown-item :to="{ name: 'AdminCustomersScreen' }"
          >Clientes</b-dropdown-item
        >
        <b-dropdown-item
          v-if="isFullEmployee"
          :to="{ name: 'AdminInvoicesScreen' }"
          >Facturas</b-dropdown-item
        >
        <b-dropdown-item
          v-if="isFullEmployee"
          :to="{ name: 'AdminWorkshopOrdersScreen' }"
          >Pedidos</b-dropdown-item
        >

        <b-dropdown-item
          v-if="isFullEmployee || isMadridEmployee"
          :to="{ name: 'AdminWorkshopStockOrdersScreen' }"
          >Pedidos (Stock)</b-dropdown-item
        >

        <b-dropdown-item
          v-if="isFullEmployee"
          :to="{ name: 'AdminDeliveriesScreen' }"
          >Albaranes</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminQuotesAllScreen',
          }"
          >Presupuestos</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item
        v-if="isFullEmployee || isBarcelonaEmployee"
        v-b-toggle:nav-collapse-bcn
        >Barcelona</b-nav-item
      >
      <b-collapse
        id="nav-collapse-bcn"
        :visible="isFullEmployee || isBarcelonaEmployee"
      >
        <b-dropdown-item
          :to="{
            name: 'AdminQuotesScreen',
            params: { location: 1 },
          }"
          >Presupuestos</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminOrdersScreen',
            params: { location: 1 },
          }"
          >Ventas</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminCashEditScreen',
            params: { location: 1 },
          }"
          >Caja</b-dropdown-item
        >

        <!-- <b-dropdown-item
          :to="{
            name: 'AdminCommissionsScreen',
            params: { location: 1 },
          }"
          >Comisiones</b-dropdown-item
        > -->

        <b-dropdown-item
          :to="{
            name: 'AdminStockLinesScreen',
            params: { location: 1 },
          }"
          >Stock</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminVouchersScreen',
            params: { location: 1 },
          }"
          >Vales devolución</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item
        v-if="isFullEmployee || isMadridEmployee"
        v-b-toggle:nav-collapse-madrid
        >Madrid</b-nav-item
      >
      <b-collapse
        id="nav-collapse-madrid"
        :visible="isFullEmployee || isMadridEmployee"
      >
        <b-dropdown-item
          :to="{
            name: 'AdminQuotesScreen',
            params: { location: 2 },
          }"
          >Presupuestos</b-dropdown-item
        >

        <!-- <b-dropdown-item
          :to="{
            name: 'AdminOrdersScreen',
            params: { location: 2 },
          }"
          >Ventas</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminCashEditScreen',
            params: { location: 2 },
          }"
          >Caja</b-dropdown-item
        > -->

        <!-- <b-dropdown-item
          :to="{
            name: 'AdminCommissionsScreen',
            params: { location: 2 },
          }"
          >Comisiones</b-dropdown-item
        > -->

        <b-dropdown-item
          :to="{
            name: 'AdminStockLinesScreen',
            params: { location: 2 },
          }"
          >Stock</b-dropdown-item
        >

        <b-dropdown-item
          :to="{
            name: 'AdminVouchersScreen',
            params: { location: 2 },
          }"
          >Vales devolución</b-dropdown-item
        >

        <!-- <b-dropdown-item :to="{ name: 'AdminCustomersScreen' }"
          >Clientes</b-dropdown-item
        > -->
      </b-collapse>

      <!-- <b-nav-item
        v-if="isFullEmployee || isMadridEmployee"
        v-b-toggle:nav-collapse-workshop
        >Taller</b-nav-item
      >
      <b-collapse
        id="nav-collapse-workshop"
        :visible="isFullEmployee || isMadridEmployee"
      >
        <b-dropdown-item
          v-if="isFullEmployee"
          :to="{ name: 'AdminOrdersScreen' }"
          >Pedidos</b-dropdown-item
        >
      </b-collapse> -->

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-ops
        >Operaciones</b-nav-item
      >
      <b-collapse v-if="isFullEmployee" id="nav-collapse-ops" :visible="false">
        <b-dropdown-item :to="{ name: 'AdminWorkshopTasksScreen' }"
          >Tareas de taller</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-inventory
        >Inventario</b-nav-item
      >
      <b-collapse
        v-if="isFullEmployee"
        id="nav-collapse-inventory"
        :visible="false"
      >
        <b-dropdown-item :to="{ name: 'AdminFabricsScreen' }"
          >Telas</b-dropdown-item
        >
        <b-dropdown-item :to="{ name: 'AdminColorsScreen' }"
          >Hilos</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminInterliningsScreen' }"
          >Entretelas</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminEmbroideredStripsScreen' }"
          >Tiras bordadas</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-productos
        >Catálogo de Artículos</b-nav-item
      >
      <b-collapse
        v-if="isFullEmployee"
        id="nav-collapse-productos"
        :visible="false"
      >
        <b-dropdown-item :to="{ name: 'AdminProductsScreen' }"
          >Artículos</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminPredefinedProductsScreen' }"
          >Artículos predefinidos</b-dropdown-item
        >
        <b-dropdown-item :to="{ name: 'AdminProductCategoriesScreen' }"
          >Categorías artículos</b-dropdown-item
        >
        <b-dropdown-item
          :to="{ name: 'AdminPredefinedProductCategoriesScreen' }"
          >Categorías artículos predefinidos</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminGenericProductAttributesScreen' }"
          >Atributos genéricos</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-attributes
        >Personalizador</b-nav-item
      >
      <b-collapse
        v-if="isFullEmployee"
        id="nav-collapse-attributes"
        :visible="false"
      >
        <b-dropdown-item :to="{ name: 'AdminProductAttributesScreen' }"
          >Atributos (L)</b-dropdown-item
        >
        <b-dropdown-item :to="{ name: 'AdminProductTemplatesScreen' }"
          >Plantillas (L)</b-dropdown-item
        >
        <b-dropdown-item :to="{ name: 'AdminProductSelectorsScreen' }"
          >Selectores</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminInitialsEditScreen' }"
          >Iniciales</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminEmbroiderySettingsScreen' }"
          >Bordados</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminFormulasScreen' }"
          >Fórmulas</b-dropdown-item
        >

        <b-dropdown-item :to="{ name: 'AdminStitchesScreen' }"
          >Puntadas</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-analytics
        >Analytics</b-nav-item
      >
      <b-collapse
        v-if="isFullEmployee"
        id="nav-collapse-analytics"
        :visible="false"
      >
        <b-dropdown-item :to="{ name: 'AdminAnalyticsDownloadsScreen' }"
          >Descargas</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item v-if="isFullEmployee" v-b-toggle:nav-collapse-web
        >Web</b-nav-item
      >
      <b-collapse v-if="isFullEmployee" id="nav-collapse-web" :visible="false">
        <b-dropdown-item :to="{ name: 'AdminWebHomeSettingsScreen' }"
          >Configuración Home</b-dropdown-item
        >
      </b-collapse>

      <b-nav-item :to="{ name: 'LogoutScreen' }">Cerrar sesión</b-nav-item>
    </b-nav>
  </b-sidebar>
</template>

<script>
import store from '@/admin/store.js';

export default {
  name: 'Sidebar',
  props: {},
  computed: {
    isFullEmployee() {
      return this.sharedState.auth.role === 'full';
    },
    isBarcelonaEmployee() {
      return this.sharedState.auth.locations.includes(1);
    },
    isMadridEmployee() {
      return this.sharedState.auth.locations.includes(2);
    },
  },
  data() {
    return {
      sharedState: store.state,
    };
  },
};
</script>

<style lang="scss" src="@/assets/css/admin/header.scss" scoped></style>
